import _ from 'lodash'
import XAxisTick from '../../../../Common/NewDashboard/Chart/XAxisTick/XAxisTick'
import {
  DATE_FORMAT,
  getMomentDateTimeFromApiData
} from '../../../../../lib/MomentHelper'

const TICK_DATE_FORMAT = `[(]${DATE_FORMAT.LINE_CHART_X_AXIS_DATE}[)]`

const CustomizeXAxisTick = (props) => {
  const { x, y, payload } = props
  const payloadValue = _.get(payload, 'value')
  if (!payloadValue) {
    return null
  }
  const tickTime = getMomentDateTimeFromApiData(payloadValue).format(
    DATE_FORMAT.CHART_X_AXIS_TIME
  )
  const tickDate = getMomentDateTimeFromApiData(payloadValue).format(
    TICK_DATE_FORMAT
  )
  const isDateVisible = tickTime === '00:00' || tickTime === '01:00'

  return (
    <XAxisTick svgProps={{ x, y }}>
      <>
        <tspan
          x={0}
          dy={isDateVisible ? 8 : 12}
        >
          {tickTime}
        </tspan>
        {isDateVisible && (
          <tspan
            x={0}
            dy={12}
          >
            {tickDate}
          </tspan>
        )}
      </>
    </XAxisTick>
  )
}

export default CustomizeXAxisTick
